// extracted by mini-css-extract-plugin
export default {"initials":"UsersTable_initials__LPpyb"};